import React from 'react'
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form'
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import Heading from '../Heading/Heading';
import PhoneNumberFormat from '../../lib/phoneNumber/PhoneNumberFormat';
import { products } from '../../services';
import isEmpty from 'lodash/isEmpty';

let ParametersForm = props => {
  const { data, translate, handleSubmit, cancel, pristine, submitting } = props;
  if (!isEmpty(data)) {
    return (
      <div className="service-action">
        <div className="card card-service-action">
          <div className="card-block container">
            {Heading(translate('apn-filter'), PhoneNumberFormat(data.phoneNumber))}
            <form onSubmit={handleSubmit}>
              <div className="form-group row">
                <div className="col-md-6 col-8 font-weight-bold align-self-end">
                  <label htmlFor="apnFilter">{translate('activate-apn-filter')}</label>
                </div>
                <div className="col-md-6 col-4 text-left">
                  <Field name="hasApnFilter" className="form-control no-min-width" id="apnFilter" component="input" type="checkbox"/>
                </div>
                <div className="col-12 warning-apn"><b>{translate('warning-apn-title')}</b>{translate('warning-apn-text')}</div>
              </div>

              <div className="row-btn form-line edit">
                <div className="row justify-content-end row-btn">
                  <div className="col-6 col-md-3">
                    <button className="btn btn-block btn-form btn-cancel" type="button"
                            onClick={ () => cancel()}>{translate('cancel')}</button>
                  </div>
                  <div className="col-6 col-md-3">
                    <button className="btn btn-block btn-form btn-submit btn-submit-save"
                            type="submit" data-target=".bd-example-modal-lg"
                            disabled={pristine || submitting}
                            data-toggle="modal">{translate('save')}</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div></div>
  );
}

ParametersForm = reduxForm({
  form: 'parameters'
})(ParametersForm)

// export default ParametersForm;
class Parameters extends React.Component {
  constructor(){
    super();
    this.state = {
      data: {}
    };
  }

  componentDidMount() {
    const { rest } = this.props;
    const ProductId = rest.computedMatch.params.userProductId;
    products.getProduct(ProductId)
      .then((res) => {
        this.setState({
          data: res.body.data.userProduct.Data,
        });
      });
  }

  submit = values => {
    const { translate, productID, setFlashMessage } = this.props;
    const { history } = this.props.matchProps;
    products.setLineParams(productID, values.hasApnFilter).then((res) => {
      if(res.status == 200) {
        setFlashMessage(`${translate('changes-saved-successfully')}`, true);
        history.goBack();
      } else {
        setFlashMessage(`${translate('changes-failed')}`, false);
      }
    })
  }

  cancel = () => {
    const { history } = this.props.matchProps;
    history.goBack();
  }

  render() {
    const { data } = this.state;
    const { translate } = this.props;
    if (!isEmpty(data)) {
      const initialValues = {hasApnFilter: !!data.hasApnFilter};
      return <ParametersForm translate={translate} data={data} initialValues={initialValues} onSubmit={this.submit} cancel={this.cancel} />
    }
    return <ParametersForm translate={translate} data={data} onSubmit={this.submit} cancel={this.cancel} />
  }
}

const mapStateToProps = (state, {rest}) => {
  return {
    translate: getTranslate(state.locale),
    currentLanguage: getActiveLanguage(state.locale).code,
    productID: rest.computedMatch.params.userProductId
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setFlashMessage: (message, success) => {
      dispatch(
        {
          type: 'SET_FLASH_MESSAGE',
          message: message,
          success: success
        }
      );
    }
  };
};

Parameters = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Parameters);

export default Parameters;



// WEBPACK FOOTER //
// ./src/components/Line/Parameters.js